"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    editPropertyDesignFloodElevation: {
        path: "/properties/:propertyId/design-flood-elevation",
    },
    createProperty: {
        path: "/properties/create",
    },
    editProperty: {
        path: "/properties/:propertyId/edit",
    },
    properties: {
        path: "/properties",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvcGVydGllcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvcHJvcGVydGllcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtQ0FBc0M7QUFFekIsUUFBQSxNQUFNLEdBQUcsSUFBQSxtQkFBVyxFQUFDO0lBQ2hDLGdDQUFnQyxFQUFFO1FBQ2hDLElBQUksRUFBRSxnREFBZ0Q7S0FDdkQ7SUFDRCxjQUFjLEVBQUU7UUFDZCxJQUFJLEVBQUUsb0JBQW9CO0tBQzNCO0lBQ0QsWUFBWSxFQUFFO1FBQ1osSUFBSSxFQUFFLDhCQUE4QjtLQUNyQztJQUNELFVBQVUsRUFBRTtRQUNWLElBQUksRUFBRSxhQUFhO0tBQ3BCO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBlZGl0UHJvcGVydHlEZXNpZ25GbG9vZEVsZXZhdGlvbjoge1xuICAgIHBhdGg6IFwiL3Byb3BlcnRpZXMvOnByb3BlcnR5SWQvZGVzaWduLWZsb29kLWVsZXZhdGlvblwiLFxuICB9LFxuICBjcmVhdGVQcm9wZXJ0eToge1xuICAgIHBhdGg6IFwiL3Byb3BlcnRpZXMvY3JlYXRlXCIsXG4gIH0sXG4gIGVkaXRQcm9wZXJ0eToge1xuICAgIHBhdGg6IFwiL3Byb3BlcnRpZXMvOnByb3BlcnR5SWQvZWRpdFwiLFxuICB9LFxuICBwcm9wZXJ0aWVzOiB7XG4gICAgcGF0aDogXCIvcHJvcGVydGllc1wiLFxuICB9LFxufSk7XG4iXX0=